// extracted by mini-css-extract-plugin
export default {"alertLongVideoContainer":"alert-long-recording-run-out_alertLongVideoContainer__ILd1a","warningIcon":"alert-long-recording-run-out_warningIcon__rICSA"};